export const APP_CONFIG_RESOURCE = 'app-config';

// A Home fica sem caminho: é a aba que abre em /app-config.
export const APP_CONFIG_TAB_PATHS = {
  home: '',
  fillin: 'abastecimento',
  coupons: 'cupons',
  rating: 'avaliacao',
  signup: 'cadastro',
  identity: 'identidade',
  stores: 'lojas',
} as const;

export const appConfigTabUrl = (path: string) => (path ? `/${APP_CONFIG_RESOURCE}/${path}` : `/${APP_CONFIG_RESOURCE}`);
